import React from 'react';

import { FormattedMessage } from 'react-intl';

import messages from '../../messages';
import style from './shopify-invalid-content.module.less';

const shopifyInvalidContent = (
  <div className={style['shopify-invalid-content']}>
    <h2>
      <FormattedMessage {...messages.shopifyChangesTitleCR} />
    </h2>
    <p>
      <FormattedMessage {...messages.shopifyChangesList} />
    </p>
    <ul>
      <li className={style.item}>
        <FormattedMessage
          {...messages.upgradeShopifyPlan}
          values={{
            a: (chunks) => (
              <a
                href='https://help.shopify.com/en/manual/intro-to-shopify/pricing-plans/plan-features#the-advanced-shopify-plan'
                rel='noreferrer'
                target='_blank'
              >
                {chunks}
              </a>
            ),
          }}
        />
      </li>
      <li className={style.item}>
        <FormattedMessage
          {...messages.addCarrierServices}
          values={{
            a: (chunks) => (
              <a
                href='https://help.shopify.com/en/manual/shipping/setting-up-and-managing-your-shipping/enabling-shipping-carriers'
                rel='noreferrer'
                target='_blank'
              >
                {chunks}
              </a>
            ),
          }}
        />
      </li>
    </ul>
  </div>
);

export default shopifyInvalidContent;
